/**
 * Whether the rotation re-auth step is behind us, so RotateView should keep
 * MfaSetupForm mounted.
 *
 * The secret alone is not enough: verifyMfaSetup clears it in the same action
 * that moves to 'success', which would drop the user back onto the re-auth
 * form instead of showing "Setup key updated".
 */
export const isRotationReauthDone = ({ mfaSetupSecret, mfaSetupStep }) =>
  !!mfaSetupSecret || mfaSetupStep !== 'setup';
